import { hasRole, type AiStatus } from '@rp/contracts'
import { Link } from '@tanstack/react-router'
import { StatusBar } from '../design'
import { AI_CREDENTIALS_SECTION_ID } from '../features/settings/aiCredentialsCopy'
import { useReadySession } from '../session/useSession'
import { useAiStatus } from './aiStatus'
import { SHELL_COPY } from './copy'

const SETTINGS_PATH = '/settings'

export interface AiPausedNoticeProps {
  status: AiStatus | null | undefined
  admin?: boolean
}

const settingsAction = (status: AiStatus, admin: boolean) =>
  admin && status.reason === 'credentials_missing'
    ? {
        action: (
          <Link to={SETTINGS_PATH} hash={AI_CREDENTIALS_SECTION_ID} className="btn btn-secondary btn-regular">
            {SHELL_COPY.aiPausedOpenSettings}
          </Link>
        ),
      }
    : {}

export const AiPausedNotice = ({ status, admin = false }: AiPausedNoticeProps) => {
  if (status?.aiPaused !== true) return null
  const reason = status.reason === null ? {} : { note: SHELL_COPY.aiPausedReasons[status.reason] }
  return (
    <div className="status-bar">
      <StatusBar
        tone="warning"
        title={SHELL_COPY.aiPausedTitle}
        detail={SHELL_COPY.aiPausedDetail}
        {...reason}
        {...settingsAction(status, admin)}
      />
    </div>
  )
}

export const AiPausedBanner = () => {
  const { membership } = useReadySession()
  return <AiPausedNotice status={useAiStatus().data} admin={hasRole(membership.role, 'admin')} />
}
